import {UPDATE_USER_CREDIT} from '../../types/actions/Auth.actions';

const initialState: any = {
  credit: 0,
  currency: null,
};

const Credit = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_USER_CREDIT: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};
export default Credit;
